import { useEffect, useState } from "react";
import axiosInstance from "../api/apiClient"
import PageLayout from "../components/PageLayout"

const Profile = () => {
    const [info, setInfo] = useState({});

    const getProfileData = async () => {
        const profileData = await axiosInstance.get('/profile');
        setInfo(profileData[0]);
        console.log(profileData[0]);
    }

    useEffect(() => {
        getProfileData();
    }, [])

    return(
        <PageLayout
            headerText="Profile"
            type="profile"
        >
            <div className="bg-white rounded-3xl shadow-lg p-4">
                <h1 className="text-2xl font-bold mb-0 text-gray-900">Welkom {info.first_name},</h1>
                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label
                                htmlFor="first_name"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                First Name
                            </label>
                            <input
                                value={info.first_name}
                                // onChange={(e) => setNewBook({...newBook, Author: e.target.value})}
                                disabled
                                type="text"
                                id="first_name"
                                className="bg-gray-50 cursor-not-allowed border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="First Name"
                                required
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="last_name"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Last Name
                            </label>
                            <input
                                value={info.last_name}
                                disabled
                                type="text"
                                id="last_name"
                                className="bg-gray-50 cursor-not-allowed border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Last Name"
                                required
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label
                                htmlFor="email"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Email
                            </label>
                            <input
                                value={info.email}
                                disabled
                                type="text"
                                id="email"
                                className="bg-gray-50 cursor-not-allowed border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Email"
                                required
                            />
                        </div>
                    </div>
                    <p className="mt-4 text-sm text-gray-500">Lid sinds: {new Date(info.created_at).toLocaleDateString('nl-NL')}</p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                        <button
                            className="cursor-not-allowed bg-gray-500 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
                            disabled
                        >
                            Wachtwoord wijzigen
                        </button>
                    </div>
            </div>
        </PageLayout>
    )
    
}

export default Profile